import { CONFIG_PASSOS_FISCAL, getInfoStep } from './constants/constant_primeiros_passos';
import { IPrimeirosPassos } from './settings_primeiros_passos';

/**
 * MODULOS:
 * - FISCAL
 */
export class SettingsPrimeirosPassosFical {
  passos = [
    {
      posicao: null,
      passo_valor: 'INFO_FISCAL',
      concluido: false,
      link: [
        {
          passo: 'EDITAR_FISCAL',
          concluido: false
        }
      ]
    },
    {
      posicao: null,
      passo_valor: 'INFO_FISCAL_REGRAS',
      concluido: false,
      link: [
        {
          passo: 'EDITAR_REGRA_FISCAL',
          concluido: false
        }
      ]
    },
    {
      posicao: null,
      passo_valor: 'INFO_CERTIFICADO',
      concluido: false,
      link: [
        {
          passo: 'EDITAR_CERTIFICADO',
          concluido: false
        }
      ]
    },
    {
      posicao: null,
      passo_valor: 'INFO_UFICMS',
      concluido: false,
      link: [
        {
          passo: 'EDITAR_UFICMS',
          concluido: false
        }
      ]
    }
  ] as IPrimeirosPassos[];

  ultimo_passo = 'UNKNONW';

  constructor(
    public configInicial: {
      passos: IPrimeirosPassos[];
      ultimo_passo: string;
    }
  ) {
    var count = 0;
    this.passos.forEach(it => {
      const index = configInicial.passos.findIndex(
        it2 => it2.passo_valor === it.passo_valor
      );
      if (index === -1) {
        configInicial.passos.push(it);
      }
    });
    configInicial.passos.forEach(it => {
      if (it.posicao !== null) count = it.posicao + 1;
      it.posicao = it.posicao !== null ? it.posicao : count++;
    });
    this.passos = configInicial.passos;
    this.ultimo_passo = configInicial.ultimo_passo;
  }

  getSettingsPassosFiscal(config_inicial: {
    passos: IPrimeirosPassos[];
    ultimo_passo: string;
  }) {
    return {
      passos: getInfoStep(this.passos, CONFIG_PASSOS_FISCAL),
      ultimo_passo: this.ultimo_passo
    };
  }
}
